import { ThemeFile } from 'lib/context/ThemeContext';

export const ProgressBarTheme: ThemeFile = {
  aw: {
    classes: {
      stepLabel: 'mt-1.5 flex-1 font-sans text-sm-xs font-heavy leading-4 md:hidden',
      stepCount: 'mt-1.5 font-sans text-sm-xs font-medium leading-4 md:hidden',
    },
  },
  rba: {
    classes: {
      stepLabel: 'mt-1.5 flex-1 font-serif text-sm-xs font-heavy  md:hidden',
      stepCount: 'mt-1.5 font-serif text-sm-xs font-heavy md:hidden',
    },
  },
};
